import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2fde2f7d&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde2f7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fde2f7d')) {
      api.createRecord('2fde2f7d', component.options)
    } else {
      api.reload('2fde2f7d', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=2fde2f7d&scoped=true&", function () {
      api.rerender('2fde2f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Product/List.vue"
export default component.exports